import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {UpdateUserGroupResultModal} from './update-user-group.result.modal';
import {
    clearResult,
    selectUpdateUserGroupShown,
    selectUpdateUserGroupTask,
    selectUpdateUserGroupUuid,
} from './update-user-group.slice';


export const UpdateUserGroupResult = () => (
    <BulkActionResult
        actionIdSelector={selectUpdateUserGroupUuid}
        actionTaskSelector={selectUpdateUserGroupTask}
        actionShownSelector={selectUpdateUserGroupShown}
        clearResult={clearResult}>
        {({id, onClose}) => <UpdateUserGroupResultModal id={id} onClose={onClose}/>}
    </BulkActionResult>
);
